import { render } from "./SideBarLogo.vue?vue&type=template&id=a0be1de2"
import script from "./SideBarLogo.vue?vue&type=script&lang=js"
export * from "./SideBarLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__